import {
    get_tipiManutenzione,
    create_tipoManutenzione,
    update_tipoManutenzione,
    duplica_tipoManutenzione,
    delete_tipoManutenzione,
} from "@/api/api.tipomanutenzione.js";

const tipiManutenzione = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipiManutenzione().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_tipoManutenzione(id, dati) : create_tipoManutenzione(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipoManutenzione(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_tipoManutenzione(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipiManutenzione;